import { Component, OnInit, Renderer2 } from "@angular/core";
import * as FileSaver from "file-saver";
import { ReportsService } from "../../../../core/services/reports.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { TableModule } from "primeng/table";
import { OrdersWrittenReportDetailResponse } from "../../../../core/models/reports/ordersWrittenReportDetailResponse";
import { LoaderService } from "../../../../core/services/loader.service";
import { CommonModule } from "@angular/common";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { OrderSummaryComponent } from "../../../orders/components/order-summary/order-summary.component";
import { ClientDetailsComponent } from "../../../clients/components/client-details/client-details.component";
import { VendorSummaryComponent } from "../../../vendors/components/vendor-summary/vendor-summary.component";

@Component({
  selector: "jni-order-written-report",
  templateUrl: "./order-written-report.component.html",
  styleUrls: ["./order-written-report.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    HidedynamicsdatePipe,
    ModalStackerComponent,
    OrderSummaryComponent,
    ClientDetailsComponent,
    VendorSummaryComponent,
  ],
})
export class OrderWrittenReportComponent implements OnInit {
  orderDisplayModal = false;
  clientDisplayModal = false;
  vendorDisplayModal = false;
  clientId = "";
  saleOrderId = "";
  vendorAccountNumber = "";

  ordersWrittenReportDetailLists: OrdersWrittenReportDetailResponse[] = [];
  filterOrdersWrittenReportDetailLists: OrdersWrittenReportDetailResponse[] =
    [];

  constructor(
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _reportsService: ReportsService,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.getOrdersWrittenReportDetail();
  }

  getOrdersWrittenReportDetail() {
    this._loaderService.setLoaderState(true);
    this._reportsService.getOrdersWrittenReportDetail().subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.ordersWrittenReportDetailLists = res.data;
          this.filterOrdersWrittenReportDetailLists =
            this.ordersWrittenReportDetailLists;
        } else {
          this._toastr.error(res.message, "Error");
        }
      },
      error: res => {
        this._loaderService.setLoaderState(false);
        this._toastr.error(res.message, "Error");
      },
    });
  }

  // onInHandDateFilter(event: any) {
  //   if (event.target.value) {
  //     const filterList = this.ordersWrittenReportDetailLists.filter((x) =>
  //       x.ihd?.includes(event.target.value)
  //     );
  //     this.filterOrdersWrittenReportDetailLists = filterList;
  //   } else {
  //     this.filterOrdersWrittenReportDetailLists =
  //       this.ordersWrittenReportDetailLists;
  //   }
  // }

  // onCreatedDateFilter(event: any) {
  //   if (event.target.value) {
  //     const filterList = this.ordersWrittenReportDetailLists.filter((x) =>
  //       x.createdDate?.includes(event.target.value)
  //     );
  //     this.filterOrdersWrittenReportDetailLists = filterList;
  //   } else {
  //     this.filterOrdersWrittenReportDetailLists =
  //       this.ordersWrittenReportDetailLists;
  //   }
  // }

  redirectToClient(client: string) {
    //const url = `/clients/active/client-details/${client}`;
    //this.route.navigate([url]);
    if (client) {
      this.clientId = client;
      this.clientDisplayModal = true;
    }
  }

  redirectToVendor(vendor: string) {
    //const url = `/vendors/vendor-summary/${vendor}`;
    //this.route.navigate([url]);
    if (vendor) {
      this.vendorAccountNumber = vendor;
      this.vendorDisplayModal = true;
    }
  }

  redirectToSaleorder(saleorder: string) {
    //const url = `/orders/order-summary/${saleorder}`;
    //this.route.navigate([url]);
    if (saleorder) {
      this.saleOrderId = saleorder;
      this.orderDisplayModal = true;
    }
  }

  exportExcelFile() {
    this.exportExcelForFilterData(this.ordersWrittenReportDetailLists);
  }

  exportExcelForFilterData(
    filterclientlist: OrdersWrittenReportDetailResponse[]
  ) {
    const object = filterclientlist.map(datum => {
      return {
        ["Sale Order"]: datum.salesOrder,
        ["Created Date"]: new Date(datum.createdDate),
        ["Client Name"]: datum.customerName,
        ["Job Name"]: datum.jobName,
        ["IHD"]: new Date(datum.ihd ?? ""),
        ["Branding Consultant"]: datum.brandingConsultant,
        ["Account Coordinator"]: datum.accountCoordinator,
        ["Status"]: datum.status,
        ["Highest Net Vendor"]: datum.highestNetVendor,
        ["Currency"]: datum.currency,
        ["Order Total"]: datum.orderSubTotal,
        ["Commission"]: datum.commission,
        ["Net GP%"]: datum.orderNetGP,
        ["Buyer"]: datum.buyer,
        ["Client PO"]: datum.clientPO,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "OrdersWrittenReport");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  closeModalForSaleOrder() {
    this.orderDisplayModal = false;
  }

  closeModalForClient() {
    this.clientDisplayModal = false;
  }

  closeModal() {
    this.vendorDisplayModal = false;
  }

  scrollHiddenStatus() {
    setTimeout(() => {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }, 0);
  }
}
